import React, {useState} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Button, Col, Row} from "antd";
import {setDirection, setMode} from "../features/omikuji/omikujiSlice";

export function Screen4_Direction(props: any) {
    const dispatch = useAppDispatch();
    return <>
        <p>どの方角を向いておみくじを引く？</p>
        <div style={{
            backgroundImage: "url('/images/directions.png')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            width: "320px",
            height: "320px",
            paddingTop: "24px",
            paddingLeft: "12px",
        }}>

            <Row style={{height: "48px"}}>
                <Col xs={24}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction1_Kita"))
                    }}>北</Button>
                </Col>
            </Row>
            <Row style={{height: "48px"}}>
                <Col xs={12}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction8_Hokusei"))
                    }}>北西</Button>
                </Col>
                <Col xs={12}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction2_Tohoku"))
                    }}>東北</Button>
                </Col>
            </Row>
            <Row><Col><br/></Col></Row>
            <Row style={{height: "48px"}}>
                <Col xs={6}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction7_Nishi"))
                    }}>西</Button>
                </Col>
                <Col xs={6}></Col>
                <Col xs={6}></Col>
                <Col xs={6}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction3_Higashi"))
                    }}>東</Button>
                </Col>
            </Row>
            <Row><Col><br/></Col></Row>
            <Row style={{height: "48px"}}>
                <Col xs={12}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction6_Nansei"))
                    }}>南西</Button>
                </Col>
                <Col xs={12}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction4_Nanto"))
                    }}>南東</Button>
                </Col>
            </Row>
            <Row style={{height: "48px"}}>
                <Col xs={24}>
                    <Button onClick={() => {
                        dispatch(setMode("mode5_Pray"))
                        dispatch(setDirection("direction5_Minami"))
                    }}>南</Button>
                </Col>
            </Row>
        </div>
    </>
}
